import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";
import { applyPlaces, applyReklame } from "@/lib/places";
import { applyCategories } from "@/lib/categories";

const queryClient = new QueryClient({
  defaultOptions: { queries: { staleTime: 30_000, refetchOnWindowFocus: false, retry: 1 } },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
let version = 0;
const render = () => root.render(
  <QueryClientProvider client={queryClient}>
    <App key={version} />
  </QueryClientProvider>
);

const applyAll = (p, c) => {
  if (p) { applyPlaces(p.countries); applyReklame(p.reklame); }
  if (c) applyCategories(c.items);
};
try { const ref = new URLSearchParams(window.location.search).get("ref"); if (ref && /^\d+$/.test(ref)) localStorage.setItem("gs_ref", ref); } catch {}
try { applyAll(JSON.parse(localStorage.getItem("gs_cfg_places")), JSON.parse(localStorage.getItem("gs_cfg_cats"))); } catch {}

const get = (u) => fetch(u).then((r) => { if (!r.ok) throw new Error(r.status); return r.json(); });
const sleep = (ms) => new Promise((r) => setTimeout(r, ms));
async function loadConfig() {
  for (let i = 0; i < 8; i++) {
    try {
      const [p, c] = await Promise.all([get("/api/places"), get("/api/categories")]);
      localStorage.setItem("gs_cfg_places", JSON.stringify(p));
      localStorage.setItem("gs_cfg_cats", JSON.stringify(c));
      applyAll(p, c);
      return true;
    } catch { await sleep(Math.min(1000 * 2 ** i, 15000)); }
  }
  return false;
}

let started = false;
const cfg = loadConfig().then((ok) => {
  if (started && ok) { version += 1; render(); }
});
Promise.race([cfg, sleep(2500)]).finally(() => { started = true; render(); });

if ("serviceWorker" in navigator) {
  navigator.serviceWorker.getRegistrations().then((regs) => {
    regs.forEach((r) => {
      const url = (r.active || r.installing || r.waiting)?.scriptURL || "";
      if (!url.endsWith("/push-sw.js")) r.unregister();
    });
  }).catch(() => {});
  if (window.caches) {
    caches.keys().then((keys) => keys.forEach((k) => caches.delete(k))).catch(() => {});
  }
}
